module.exports = __webpack_public_path__ + "img/title.50ab556b.png";